
export default class OParam {
  constructor () {
    this.paramType = null;
    this.paramObject = null;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/OParam.js